module.exports = __webpack_public_path__ + "images/marketing/logo-rethink-autism.png";